<div class="loader" [class.cargando]="!this.enProceso"><img src="" class="ld ld-beat" alt="" />
</div>